<wm-form-activity-input-view
  [activity]="activity"
  [form]="form"
  [applicationId]="applicationId"
  #formActivityInputView
></wm-form-activity-input-view>
